import { api } from './client';

export interface MeetingRoom {
  id: string;
  orgId: string;
  kioskIds: string[];
  name: string;
  roomEmail: string;
  azureTenantId?: string;
  azureClientId?: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface MeetingEvent {
  id: string;
  subject: string;
  organizer?: string;
  startTime: string;
  endTime: string;
  isAllDay: boolean;
  status: 'busy' | 'free' | 'tentative';
  attendeeCount?: number;
}

export const meetingRoomsApi = {
  list: async (): Promise<MeetingRoom[]> => {
    const response = await api.get('/meeting-rooms');
    return response.data;
  },

  getEvents: async (roomId: string, date?: string): Promise<MeetingEvent[]> => {
    const response = await api.get(`/meeting-rooms/${roomId}/events`, {
      params: date ? { date } : undefined,
    });
    return response.data;
  },
};
